import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>({...props.rowData})

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)

    _.set(nextData, "inputtype", "basic")
    _.set(nextData, "payoutdetail", null)

    nextData[field] = localCache[field] = val

    setData(localCache)
    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('payout')(field)(props.rowData, props)

  return (
    <div className="payout-basic-container ">
      <SingleRowCarouselState_s>
        <div>
          <label>Month</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="mosoffset" readPrecision={0} writePrecision={0} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic
